const palette = {
  tertiary: {
    main: "#041E44",
    purple: "#9E68AF",
    green: "#0A8043",
    primaryAccent: "#00B0ED",
  },
  primary: {
    main: "#0050C8",
    light: "#F0F5FF",
    shade: "#80ACFF",
    border: "#CDCED9",
  },
  secondary: {
    main: "#A7A9BC",
    light: "#E7E7ED",
  },
  border: {
    primary: "#458FFF",
    error: "#F48989",
    success: "#54CA75",
    tableBorder: "#EDEDED",
    default: "#CDCED9",
  },
  success: {
    dark: "#287D3C",
    main: "#D4F7DC",
    light: "#D4F7DC",
  },
  info: {
    main: "#F0F5FF",
    light: "#458FFF",
    dark: "#0050C8",
  },
  warning: {
    main: "#E0B878",
    light: "#FFF5EA",
    dark: "#B98900",
  },
  error: {
    main: "#F48989",
    light: "#FEEFEF",
    dark: "#DA1414",
  },
  background: {
    default: "#F5F7FA",
    secondary: "#F8F7FA",
    tableHeader: "#F5F5F5",
    generalLight: "#FAFAFA",
    success: "#0A8043",
    disabled: "#A7A9BC",
    blueShadeLight: "#F1F2F6",
    lightGreen: "#EDF9F0",
    avatar: "#4F6BED",
    primaryLight: "#DBE8FF",
    primaryGrey: "#E5E5EA",
  },
  text: {
    black: "#000",
    primary: "#393A4A",
    secondary: "#6B6C7E",
    title: "#272833",
    success: "#15692A",
    primaryLight: "#E5E5EA",
    error: "#C3635D",
  },
};

export default palette;
